export default {
  getImgIconAlarm () {
    let imgIconAlarm = [
      { imgUrl: '/static/tableIcon/default.png' }, // 0
      { imgUrl: '/static/tableIcon/nb_co.png' }, // 1
      { imgUrl: '/static/tableIcon/f_test.png' }, // 2
      { imgUrl: '/static/tableIcon/f_lb.png' }, // 3
      { imgUrl: '/static/tableIcon/c_link.png' }, // 4
      { imgUrl: '/static/tableIcon/sub_gas.png' }, // 5
      { imgUrl: '/static/tableIcon/sub_keysos.png' }, // 6
      { imgUrl: '/static/tableIcon/sub_infrared.png' }, // 7
      { imgUrl: '/static/tableIcon/sub_water.png' }, // 8
      { imgUrl: '/static/tableIcon/sub_opendoor.png' }, // 9
      { imgUrl: '/static/tableIcon/sos.png' }, // 10
      { imgUrl: '/static/tableIcon/lowpower.png' }, // 11
      { imgUrl: '/static/tableIcon/sub_temp.png' }, // 12
      { imgUrl: '/static/tableIcon/sub_humidity.png' }, // 13
      { imgUrl: '/static/tableIcon/sub_level.png' }, // 14
      { imgUrl: '/static/tableIcon/sub_pressure.png' }, // 15
      { imgUrl: '/static/tableIcon/remove.png' }, // 16
      { imgUrl: '/static/tableIcon/outage.png' }, // 17
      { imgUrl: '/static/tableIcon/falldown.png' }, // 18
      { imgUrl: '/static/tableIcon/heartrate.png' }, // 19
      { imgUrl: '/static/tableIcon/phone.png' }, // 20
      { imgUrl: '/static/tableIcon/birthday.png' }, // 21
      { imgUrl: '/static/tableIcon/nonetwork.png' }, // 22
      { imgUrl: '/static/tableIcon/opendoor.png' }, // 23
      { imgUrl: '/static/tableIcon/closedoor.png' } // 24
    ]
    return imgIconAlarm
  },
  getImgIconDevice () {
    let imgIcon = [
      {dtype: 0, imgUrl: '/static/tableDevice/table_0.png'}, // 默认
      {dtype: 700, imgUrl: '/static/tableDevice/table_700.png'}, // 家庭数字基座
      {dtype: 300, imgUrl: '/static/tableDevice/table_300.png'}, // 手表
      {dtype: 901, imgUrl: '/static/tableDevice/table_901.png'}, // 随身通
      {dtype: 902, imgUrl: '/static/tableDevice/table_902.png'}, // 4G拉绳报警器
      {dtype: 903, imgUrl: '/static/tableDevice/table_901.png'}, // 随身通
      {dtype: 504, imgUrl: '/static/tableDevice/table_504.png'}, // 门磁
      {dtype: 506, imgUrl: '/static/tableDevice/table_506.png'}, // NB烟感
      {dtype: 507, imgUrl: '/static/tableDevice/table_507.png'}, // NB无线按钮
      {dtype: 508, imgUrl: '/static/tableDevice/table_504.png'}, // NB门磁
      {dtype: 509, imgUrl: '/static/tableDevice/table_509.png'}, // 智能锁
      {dtype: 510, imgUrl: '/static/tableDevice/table_510.png'}, // NB水浸
      {dtype: 511, imgUrl: '/static/tableDevice/table_511.png'}, // NB断电报警
      {dtype: 601, imgUrl: '/static/tableDevice/table_601.png'}, // UWB睡眠仪
      {dtype: 602, imgUrl: '/static/tableDevice/table_601.png'}, // UWB睡眠仪
      {dtype: 612, imgUrl: '/static/tableDevice/table_601.png'}, // UWB睡眠仪
      {dtype: 613, imgUrl: '/static/tableDevice/table_601.png'}, // 4G UWB睡眠仪
      {dtype: 850, imgUrl: '/static/tableDevice/table_850.png'}, // 壁挂信息屏
      {dtype: 851, imgUrl: '/static/tableDevice/table_851.png'}, // 床头探视终端
      {dtype: 852, imgUrl: '/static/tableDevice/table_851.png'}, // 移动护理终端
      {dtype: 904, imgUrl: '/static/tableDevice/table_511.png'}, // 断电报警
      {dtype: 905, imgUrl: '/static/tableDevice/table_511.png'}, // 断电报警
      {dtype: 350, imgUrl: '/static/tableDevice/table_300.png'}, // 手表-HX99
      {dtype: 405, imgUrl: '/static/tableDevice/table_405.png'}, // WIFI雷达
      {dtype: 406, imgUrl: '/static/tableDevice/table_406.png'}, // 睡眠仪
      {dtype: 407, imgUrl: '/static/tableDevice/table_405.png'}, // WIFI跌倒雷达
      {dtype: 310, imgUrl: '/static/tableDevice/table_300.png'}, // 4G手表-WN
      {dtype: 311, imgUrl: '/static/tableDevice/table_300.png'}, // 4G手表-YT
      {dtype: 312, imgUrl: '/static/tableDevice/table_300.png'}, // 4G手表-JD
      {dtype: 351, imgUrl: '/static/tableDevice/table_351.png'}, // 智慧胸卡
      {dtype: 352, imgUrl: '/static/tableDevice/table_351.png'}, // 智慧胸卡
      {dtype: 353, imgUrl: '/static/tableDevice/table_351.png'}, // 智慧胸卡
      {dtype: 750, imgUrl: '/static/tableDevice/table_750.png'}, // 4G血压计
      {dtype: 751, imgUrl: '/static/tableDevice/table_751.png'}, // 4G温湿度
      {dtype: 402, imgUrl: '/static/tableDevice/table_504.png'}, // Wi-Fi门磁
      {dtype: 752, imgUrl: '/static/tableDevice/table_405.png'}, // 存在感应
      {dtype: 331, imgUrl: '/static/tableDevice/table_902.png'}, // 博实结4G拉绳
      {dtype: 753, imgUrl: '/static/tableDevice/table_751.png'}, // 4G温湿度
      {dtype: 536, imgUrl: '/static/tableDevice/table_506.png'}, // 4G烟感
      {dtype: 537, imgUrl: '/static/tableDevice/table_507.png'}, // 4G拉绳按钮
      {dtype: 538, imgUrl: '/static/tableDevice/table_504.png'}, // 4G门磁
      {dtype: 539, imgUrl: '/static/tableDevice/table_509.png'}, // 4G智能锁
      {dtype: 540, imgUrl: '/static/tableDevice/table_510.png'}, // 4G水浸
      {dtype: 541, imgUrl: '/static/tableDevice/table_511.png'}, // 4G断电报警
      {dtype: 542, imgUrl: '/static/tableDevice/table_506.png'}, // 4G烟感
      {dtype: 754, imgUrl: '/static/tableDevice/table_754.png'}, // 4G睡眠垫
      {dtype: 533, imgUrl: '/static/tableDevice/table_533.png'}, // 灭火器压力表
      {dtype: 534, imgUrl: '/static/tableDevice/table_504.png'}, // 门磁（疫情）
      {dtype: 780, imgUrl: '/static/tableDevice/table_405.png'}, // 4G跌倒雷达
      {dtype: 313, imgUrl: '/static/tableDevice/table_300.png'}, // 4G手表
      {dtype: 330, imgUrl: '/static/tableDevice/table_300.png'} // 4G手表-BSJ
    ]
    return imgIcon
  }
}



// WEBPACK FOOTER //
// ./src/common/getImgArr.js